import { createContext } from "react"

export const DragContext = createContext({})
